import { Reducer } from 'redux';
import { IRedactedField } from '../common/defaults';
import { RedactedFieldsActionTypes } from './actions';
import RedactedFields from '../RedactedFields';

// Type-safe initialState!
const initialState = {
  redactedFields: []
};

type IRedactedFieldStoreState = Readonly<typeof initialState>;

const reducer: Reducer<IRedactedFieldStoreState> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case RedactedFieldsActionTypes.GET_REDACTED_FIELDS: {
      let _state = { ...state };
      _state = { ..._state, redactedFields: action.value };
      return _state;
    }
    case RedactedFieldsActionTypes.SAVE_REDACTED_FIELD: {
      let _state = { ...state };
      _state.redactedFields = [
        ..._state.redactedFields.map(x =>
          x.fieldName == action.value.fieldName ? { ...x, ...action.value } : x
        )
      ];
      return _state;
    }
    default: {
      return state;
    }
  }
};

export default reducer;
